/* eslint-disable @typescript-eslint/no-unused-vars */
import ih from 'immutability-helper';
import { cloneDeep } from 'lodash';

import * as types from './actionTypes';
import {
  UPDATE_FIELD_SUCCESS,
  SYNC_FIELDS_SUCCESS,
} from '../fields/actionTypes';
import initialState from './initialState';
import { SELECT_PROJECT } from '../../services/project/actionTypes';

export const updateFieldsNames = (tasks, updatedFields) =>
  tasks.map(task => {
    const updatedField = updatedFields.find(f => f.id === task.field.id);
    return updatedField
      ? ih(task, {
          field: {
            name: {
              $set: updatedField.name,
            },
          },
        })
      : task;
  });

const handleSyncFieldsSuccess = (state, action) => {
  const updatedFields = action.payload.updated;
  return ih(state, {
    show: {
      data: {
        $apply: data =>
          Object.entries(data).reduce((acc, [targetId, targetData]) => {
            acc[targetId] = ih(targetData, {
              tasks: {
                $apply: tasks => updateFieldsNames(tasks, updatedFields),
              },
            });
            return acc;
          }, {}),
      },
    },
  });
};

export default (state = cloneDeep(initialState), action = {}) => {
  switch (action.type) {
    case types.GET_TARGETS_REQUEST:
      return ih(state, {
        list: {
          isLoading: { $set: true },
        },
      });
    case types.GET_TARGETS_SUCCESS:
      return ih(state, {
        list: {
          $merge: {
            isLoading: false,
            data: action.payload.targets,
          },
        },
      });
    case types.GET_TARGETS_ERROR:
      return ih(state, {
        list: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.ADD_TARGET_REQUEST:
      return ih(state, {
        add: {
          isLoading: { $set: true },
        },
      });
    case types.ADD_TARGET_SUCCESS:
      return ih(state, {
        add: {
          isLoading: { $set: false },
        },
      });
    case types.ADD_TARGET_ERROR:
      return ih(state, {
        add: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.UPDATE_TARGET_REQUEST:
      return ih(state, {
        update: {
          isLoading: { $set: true },
        },
        info: {
          isLoading: { $set: true },
        },
        show: {
          isLoading: { $set: true },
        },
      });
    case types.UPDATE_TARGET_SUCCESS:
      return ih(state, {
        update: {
          isLoading: { $set: false },
        },
        show: {
          isLoading: { $set: false },
          data: {
            $apply: data => {
              const { item } = action.payload;

              return ih(data, {
                $merge: {
                  [item.id]: item,
                },
              });
            },
          },
        },
        info: {
          $merge: {
            isLoading: false,
            data: action.payload.item,
          },
        },
      });
    case types.CLEAR_DEFAULT_TARGETS:
      return ih(state, {
        show: {
          data: {
            $apply: data =>
              Object.entries(data).reduce((acc, [targetId, targetData]) => {
                acc[targetId] = ih(targetData, {
                  $merge: {
                    default: false,
                  },
                });

                return acc;
              }, {}),
          },
        },
      });
    case types.UPDATE_TARGET_ERROR:
      return ih(state, {
        update: {
          $merge: { isLoading: false, error: action.payload.error },
        },
        info: {
          isLoading: { $set: false },
        },
        show: {
          isLoading: { $set: false },
        },
      });
    case types.DUPLICATE_TARGET_REQUEST:
      return ih(state, {
        duplicate: {
          isLoading: { $set: true },
        },
      });
    case types.DUPLICATE_TARGET_SUCCESS:
      return ih(state, {
        duplicate: {
          $merge: { isLoading: false, isOpen: false },
        },
      });
    case types.DUPLICATE_TARGET_ERROR:
      return ih(state, {
        duplicate: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.OPEN_DUPLICATE_TARGET_MODAL:
      return ih(state, {
        duplicate: {
          $merge: { isOpen: true, data: action.payload.targetData },
        },
      });
    case types.CLOSE_DUPLICATE_TARGET_MODAL:
      return ih(state, {
        duplicate: {
          $merge: { isOpen: false, data: { targetId: '', targetName: '' } },
        },
      });
    case types.GET_TARGET_REQUEST:
      return ih(state, {
        show: {
          isLoading: { $set: true },
        },
      });
    case types.GET_TARGET_SUCCESS:
      return ih(state, {
        show: {
          isLoading: { $set: false },
          data: {
            $apply: data => {
              const { item } = action.payload;

              return ih(data, {
                $merge: {
                  [item.id]: item,
                },
              });
            },
          },
        },
      });
    case types.GET_TARGET_ERROR:
      return ih(state, {
        show: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.GET_TARGET_INFO_REQUEST:
      return ih(state, {
        info: {
          isLoading: { $set: true },
        },
      });
    case types.GET_TARGET_INFO_SUCCESS:
      return ih(state, {
        info: {
          $merge: {
            isLoading: false,
            data: action.payload.info,
          },
        },
      });
    case types.GET_TARGET_INFO_ERROR:
      return ih(state, {
        info: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.DELETE_TARGET_SUCCESS:
      return ih(state, {
        show: {
          data: {
            $unset: [action.payload.resourceId],
          },
        },
      });
    case SELECT_PROJECT:
      return ih(state, {
        $set: initialState,
      });
    case types.EMPTY_TARGET_INFO:
      return ih(state, {
        info: {
          $set: {},
        },
      });
    case SYNC_FIELDS_SUCCESS: {
      return handleSyncFieldsSuccess(state, action);
    }
    case UPDATE_FIELD_SUCCESS: {
      const fieldUpdated = action.payload.item;
      return ih(state, {
        show: {
          data: {
            $apply: data =>
              Object.entries(data).reduce((acc, [targetId, targetData]) => {
                acc[targetId] = ih(targetData, {
                  tasks: {
                    $apply: tasks =>
                      tasks.map(task =>
                        ih(task, {
                          field: {
                            $set:
                              task.field.id === fieldUpdated.id
                                ? fieldUpdated
                                : task.field,
                          },
                        }),
                      ),
                  },
                });
                return acc;
              }, {}),
          },
        },
      });
    }
    default:
      return state;
  }
};
